import { InputBase, Stack, TextField, type TextFieldProps } from '@mui/material'
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium'
import { forwardRef } from 'react'
import { DatePicker } from '@omnea-app/fe-date-pickers/DatePicker'
import { dateIsValid } from '@omnea-app/packages/universal/date-utils/dateIsValid'
import { parseDateString } from '@omnea-app/packages/universal/date-utils/parseDateString'
import { checkAndStopCellEditMode } from './utils/CheckAndSetMode'

const toPickerDate = (value: unknown) => parseDateString(value) ?? null
const toEditValue = (date: Date | null) => (date != null && dateIsValid(date) ? date : null)

export const DateEditCell = ({ id, value, field }: GridRenderEditCellParams): React.ReactElement => {
  const apiRef = useGridApiContext()

  return (
    <Stack sx={{ flexGrow: 1, paddingLeft: 3 }}>
      <DatePicker
        value={toPickerDate(value)}
        onChange={(date) => void apiRef.current?.setEditCellValue({ id, field, value: toEditValue(date) })}
        onClose={() => checkAndStopCellEditMode(apiRef, id, field)}
        fullWidth
        slots={{ textField: DateEditCellTextField }}
      />
    </Stack>
  )
}

// A picker keeps the `slots` it forwards for its own, so the unstyled input has to be set on the
// component the picker is given as its field.
const DateEditCellTextField = forwardRef<HTMLDivElement, TextFieldProps>((props, ref) => (
  <TextField {...props} ref={ref} slots={{ input: InputBase }} />
))

DateEditCellTextField.displayName = 'DateEditCellTextField'
